<template>
  <q-item-section
    v-if="isEnabled"
    v-bind="$attrs"
    :avatar="avatar"
    :top="top"
    :side="side"
  >
    <slot />
  </q-item-section>
  <div v-else variant="custom" v-bind="$attrs">
    <div class="font-normal leading-normal text-sm visible cursor-pointer m-0 p-0 w-auto min-w-0 max-w-full flex flex-wrap flex-col justify-center whitespace-nowrap">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpItemSection");

defineOptions({
  name: "dtpItemSection",
  inheritAttrs: false
});

withDefaults(
  defineProps<{
    avatar?: boolean;
    top?: boolean;
    side?: boolean;
  }>(),
  {
    avatar: false,
    top: false,
    side: false
  }
);
</script>
